export default __webpack_public_path__ + "a27058fe208b32642f28f90bac717726.svg";